import { CobuStack, CobuText } from '@cobu/ui'
import { Strings } from '../constants/Strings'

/**
 * "Powered by Cobu", rendered identically in the sticky top bar and on the welcome
 * screen so the brand carries through past onboarding. Deliberately text-only: the
 * icon treatment is on hold until design supplies a standalone mark.
 */
export default function BrandBadge() {
  const strings = Strings.get()

  return (
    <CobuStack layout="horizontal" gap="$1" ai="center">
      <CobuText variant="body" color="$colorMuted" fos="$1">
        {strings.branding.poweredBy}
      </CobuText>
      <CobuText variant="subheading" fow="$semibold" fos="$2">
        {strings.branding.name}
      </CobuText>
    </CobuStack>
  )
}
